module.exports = __webpack_public_path__ + "media/images/icon__point--white@3x-6e165037440433da7bba08db557f4a98.png";